import React from 'react'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import WomanWalk from '../../commons/Ilustrations/WomanWalk'

const ConfirmRegisterEmailFailContainer = () => {
  return (
    <ExternalLayout>
      <FeedbackLayout
        title="Não conseguimos validar seu e-mail"
        subTitle="Não foi possível fazer a validação do seu e-mail, solicite um novo e-mail de confirmação ou tente novamente mais tarde."
        secondaryAction={() => history.push(routes.root.path)}
        secondaryLabelAction="OK"
        Ilustration={WomanWalk}
        textAlign="left"
      />
    </ExternalLayout>
  )
}

export default ConfirmRegisterEmailFailContainer
